export default {
	URL: 'https://api-valedaserra.infinitum-ti.com',
	API_URL: 'https://api-valedaserra.infinitum-ti.com/api',
	OAPI_URL: 'https://api-valedaserra.infinitum-ti.com/oapi',
	// URL: 'http://localhost:2408',
	// API_URL: 'http://localhost:2408/api',
	// OAPI_URL: 'http://localhost:2408/oapi',
}
